import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import styles from './styles';
import { asCurrency, fullNumber } from '../utils/numberUtils';

interface MarketSummaryProps {
  market: string;
  beds: string;
  medianRent: number | null;
  monthlyChange: number | null;
  yearlyChange: number | null;
  avgDaysOnMarket: number | null;
  availableRentals: number | null;
}

const MarketSummary: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<MarketSummaryProps>>> = (
  props,
) => {
  const { market, beds, medianRent, monthlyChange, yearlyChange, avgDaysOnMarket, availableRentals } = props;

  const filterDescription =
    beds === 'All beds'
      ? 'all bedrooms and all property types'
      : `${beds !== '0' ? `${beds} bedroom` : 'studio'} properties`;

  return (
    <View style={styles.marketSummary}>
      <Text style={styles.h4}>{`${market} Market Summary`}</Text>
      {medianRent !== null && (
        <Text style={styles.body}>
          The median rent for {filterDescription} in {market} is{' '}
          <Text style={styles.bodyHeading}>{asCurrency(medianRent)}.</Text>
        </Text>
      )}
      <View style={styles.marketSummaryFlex}>
        {medianRent !== null && (
          <View style={styles.marketSummaryFlexItem}>
            <Text style={styles.body}>Median Rent</Text>
            <Text>{asCurrency(medianRent)}</Text>
          </View>
        )}
        {monthlyChange !== null && (
          <View style={styles.marketSummaryFlexItem}>
            <Text style={styles.body}>Month-Over-Month Change</Text>
            <Text>
              {monthlyChange > 0 && '+'}
              {asCurrency(monthlyChange)}
            </Text>
          </View>
        )}
        {yearlyChange !== null && (
          <View style={styles.marketSummaryFlexItem}>
            <Text style={styles.body}>Year-Over-Year Change</Text>
            <Text>
              {yearlyChange > 0 && '+'}
              {asCurrency(yearlyChange)}
            </Text>
          </View>
        )}
        {avgDaysOnMarket !== null && (
          <View style={styles.marketSummaryFlexItem}>
            <Text style={styles.body}>Avg. Days On Market</Text>
            <Text>{fullNumber(Math.round(avgDaysOnMarket))}</Text>
          </View>
        )}
        {availableRentals !== null && (
          <View style={styles.marketSummaryFlexItem}>
            <Text style={styles.body}>Available Rentals</Text>
            <Text>{fullNumber(availableRentals)}</Text>
          </View>
        )}
      </View>
      <Text style={styles.body}>Source: Zillow Rentals Data</Text>
    </View>
  );
};

export default MarketSummary;
